export interface User {
	NOME: string;
	EMAIL: string;
	CODPESSOAUSUARIO: number;
	RA?: string;
	ENTRARCOMO: UserType;
	CODCOLIGADA?: number;
	CODFILIAL: number;
	CODTIPOCURSO: number;
	IDPERLET?: string;
	PERLETIDS?: string[];
	CODPERLET: string;
	PERLETCODS?: string[];
	IDHABILITACAOFILIAL: number;
	CODCURSO: string;
	CURSO: string;
	TITULACAO: string;
	CRMPROF: string;
	CODUSUARIO: string;
	CODPROF?: string;
}

export enum UserType {
	ALUNO = 'A',
	PROFESSOR = 'P',
	COMUM = '*',
}
